import { useMemo } from 'react'
import { Group, Line } from 'react-konva'
import { useMapStore } from '@/stores/mapStore'
import type { PointType } from '@/api/services/layer.service'
import type { MetablockNodes } from '@/api/services/project.service'
import { getMapCoordinates } from './mapCoordinates'

type StartEndMarkerProps = {
  point?: PointType
  options: {
    labelSize: number
  }
  nodes: MetablockNodes
}

const StartEndMarker = ({ point, options, nodes }: StartEndMarkerProps) => {
  const [width, height] = useMapStore((state) => state.size)

  const coords = useMemo(() => {
    if (!point) return null

    return {
      x: getMapCoordinates(width, point.x),
      y: getMapCoordinates(height, point.y),
    }
  }, [point, width, height])

  if (!point || !coords) return null

  const node = nodes[point.type_uid]
  const sizeK = point.size_k * (node?.size_k ?? 1)
  const shapeSize = width * options.labelSize * sizeK

  return (
    <Group x={coords.x} y={coords.y - shapeSize / 2 - 12}>
      <Line
        points={[
          0,
          0,
          -shapeSize * 0.4,
          -shapeSize * 0.8,
          shapeSize * 0.4,
          -shapeSize * 0.8,
        ]}
        closed
        fill="#ffc107"
        shadowColor="#000"
        shadowBlur={8}
        shadowOpacity={0.25}
      />
    </Group>
  )
}

export default StartEndMarker
